<script setup>
  import { ref, onMounted, computed, watch } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import PageHeader from "@/components/ui/PageHeader";
  import BasicButton from "@/components/ui/BasicButton";
  import IconWithLabel from "@/components/ui/IconWithLabel";
  import ClientList from "@/components/ClientList.vue";
  import { useAuthStore } from "@/stores/AuthStore";
  import { RosterService } from "@/services/RosterService";

  const clients = ref([]);
  const currentPage = useRoute();
  const router = useRouter();
  const authStore = useAuthStore();

  const showArchivedClients = computed(() => {
    return currentPage.meta.showArchived;
  });

  const clientScope = computed(() => {
    return showArchivedClients.value ? "Archived" : "Active";
  });

  async function fetchClients() {
    clients.value = await RosterService.fetchMergedClients({
      accountPrefixId: authStore.currentUser.account.prefix_id,
      trainerId: authStore.currentUser.id,
      archived: showArchivedClients.value,
    });
  }

  watch(currentPage, () => {
    fetchClients();
  });
  onMounted(() => {
    fetchClients();
  });
</script>
<template>
  <div>
    <PageHeader :title="`${clientScope} Clients`">
      <template #details>
        <IconWithLabel icon="users">
          Showing all {{ clientScope }} clients
        </IconWithLabel>
      </template>
      <template #actions>
        <BasicButton
          classes="mr-2"
          @click="router.push({ name: showArchivedClients ? 'ActiveClientsPage' : 'ArchivedClientsPage' })"
        >
          Show {{ !showArchivedClients ? "Archived" : "Active" }}
        </BasicButton>
        <BasicButton
          icon="plus"
          primary
          @click="router.push({ name: 'InviteClientPage' })"
        >
          Invite Client
        </BasicButton>
      </template>
    </PageHeader>
    <div class="bg-white shadow overflow-hidden sm:rounded-md mt-8">
      <ClientList :clients="clients" />
    </div>
  </div>
</template>

